//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.Dimension.js";
import "../no/Dimensions.js";
let d=[[[0,"IsOccurrence",0,0],[0,"JournalIdentifier",0,0],[0,"Name",0,0],[0,"OwningComponent",0,"Assemblies.Component",0],[0,"OwningPart",0,"BasePart",0],[0,"Prototype",0,"INXObject",0]],[[[],"GetDoglegData",{R_:{ordinate_dogleg_preferences:''}},0,0],[["ordinate_dogleg_preferences"],"SetDoglegData",{},1,0],[[],"GetOrdinateOrigin",{R_:{ordinateOrigin:"Annotations.OrdinateOriginDimension"}},0,0],[[],"NavigateToOrigin",{},0,0],[[],"GetTolerance",{R_:{tolerance:"Annotations.LinearTolerance"}},0,0],[["tolerance"],"SetTolerance",{},1,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[[],"Print",{},0,0],[["name"],"SetName",{},1,0]],[]];
SPLM.Annotations.OrdinateDimension = class extends SPLM.Annotations.Dimension{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.OrdinateDimension";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.OrdinateDimension.DoglegPreferences = class{
    constructor(dogleg_setting,angle,start_offset,end_offset,dogleg_option){
        this.dogleg_setting=dogleg_setting;this.angle=angle;this.start_offset=start_offset;this.end_offset=end_offset;this.dogleg_option=dogleg_option;}
    get DoglegSetting(){return this.dogleg_setting}
    set DoglegSetting(val){this.dogleg_setting = val}
    get Angle(){return this.angle}
    set Angle(val){this.angle = val}
    get StartOffset(){return this.start_offset}
    set StartOffset(val){this.start_offset = val}
    get EndOffset(){return this.end_offset}
    set EndOffset(val){this.end_offset = val}
    get DoglegOption(){return this.dogleg_option}
    set DoglegOption(val){this.dogleg_option = val}
};

export default SPLM;